<template>
  <div class="donut">
    <svg :viewBox="`0 0 ${size} ${size}`" class="donut-svg">
      <circle :cx="size / 2" :cy="size / 2" :r="radius" fill="none" stroke="#f1edf5" :stroke-width="thickness" />
      <circle
        v-for="seg in segments"
        :key="seg.label"
        :cx="size / 2"
        :cy="size / 2"
        :r="radius"
        fill="none"
        :stroke="seg.color"
        :stroke-width="thickness"
        :stroke-dasharray="`${seg.length} ${circumference - seg.length}`"
        :stroke-dashoffset="-seg.offset"
        :transform="`rotate(-90 ${size / 2} ${size / 2})`"
      >
        <title>{{ seg.label }} : {{ seg.display }} ({{ seg.share }} %)</title>
      </circle>
      <text :x="size / 2" :y="size / 2 + 5" text-anchor="middle" class="donut-total">{{ totalLabel }}</text>
    </svg>
    <ul class="donut-legend">
      <li v-for="seg in segments" :key="seg.label">
        <span class="donut-dot" :style="{ background: seg.color }"></span>
        <span class="donut-label">{{ seg.label }}</span>
        <strong>{{ seg.share }} %</strong>
      </li>
    </ul>
  </div>
</template>

<script>
import { compact, PALETTE } from './widgetFetch'

// Donut SVG léger (répartition), sans dépendance Chart.js
export default {
  name: 'MiniDonut',

  props: {
    // [{ label, value, color? }]
    items: { type: Array, default: () => [] },
    size: { type: Number, default: 120 }
  },

  computed: {
    thickness() {
      return this.size * 0.16
    },

    radius() {
      return this.size / 2 - this.thickness / 2
    },

    circumference() {
      return 2 * Math.PI * this.radius
    },

    total() {
      return this.items.reduce((s, it) => s + (it.value > 0 ? it.value : 0), 0)
    },

    totalLabel() {
      return compact(this.total)
    },

    segments() {
      let offset = 0
      return this.items
        .filter(it => it.value > 0)
        .sort((a, b) => b.value - a.value)
        .map((it, idx) => {
          const length = this.total ? it.value / this.total * this.circumference : 0
          const seg = { label: it.label, color: it.color || PALETTE[idx % PALETTE.length], length, offset, display: compact(it.value), share: this.total ? Math.round(it.value / this.total * 100) : 0 }
          offset += length
          return seg
        })
    }
  }
}
</script>

<style scoped>
.donut {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
  min-height: 0;
}
.donut-svg {
  flex: 0 0 auto;
  width: 45%;
  max-width: 160px;
  max-height: 100%;
}
.donut-total {
  font-size: 15px;
  font-weight: 700;
  fill: #121826;
}
.donut-legend {
  flex: 1;
  min-width: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 100%;
  overflow-y: auto;
}
.donut-legend li {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 0;
  font-size: 12px;
  color: #555e75;
}
.donut-dot {
  flex: 0 0 auto;
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
.donut-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.donut-legend strong {
  color: #121826;
}
</style>
